<template>
  <div>
    <div :class="$style.head" aria-hidden="true">
      <lv-heading
        level="3"
        tag="h1"
        version2
        :class="$style.title"
      >
        {{ $awt('aw.pages.csr.tab_title') }}
      </lv-heading>
      <aw-csr-animation :class="$style.auchanLogo" />
      <aw-csr-line :class="$style.line" />
    </div>
    <aw-red-tabs :tabs="tabs">
      <template #default="{ content }">
        <div v-html="content" />
      </template>
    </aw-red-tabs>
  </div>
</template>

<script>
  import AwCsrAnimation from './AwCsrAnimation';
  import AwCsrLine from './AwCsrLine.vue';
  import { LvHeading } from '~~/common/components/loginet-vue-shop/index';
  import AwRedTabs from '~~/common/components/Common/AwRedTabs/AwRedTabs.vue';
  import { ref } from 'vue';
  import { useNuxtApp } from 'nuxt/app';
  import SingleCoupleImage from '~~/shop/app/assets/images/sustainability/single-couple.svg';
  import FoodImage from '~~/shop/app/assets/images/sustainability/food.svg';
  import PlanetImage from '~~/shop/app/assets/images/sustainability/planet.svg';

  export default {
    name: 'AwCrsTabs',
    components: {
      LvHeading,
      AwCsrAnimation,
      AwCsrLine,
      AwRedTabs,
    },
    setup () {
      const nuxtApp = useNuxtApp();
      const tabs = ref([
        {
          name: nuxtApp.$awt('aw.pages.csr.tabs.people.title'),
          icon: SingleCoupleImage,
          contentId: 'people',
          content: nuxtApp.$awt('aw.pages.csr.tabs.people.content'),
        },
        {
          name: nuxtApp.$awt('aw.pages.csr.tabs.planet.title'),
          icon: PlanetImage,
          contentId: 'planet',
          content: nuxtApp.$awt('aw.pages.csr.tabs.planet.content'),
        },
        {
          name: nuxtApp.$awt('aw.pages.csr.tabs.food.title'),
          icon: FoodImage,
          contentId: 'food',
          content: nuxtApp.$awt('aw.pages.csr.tabs.food.content'),
        },
      ]);

      return {
        tabs,
      };
    },
  };

</script>


<style module lang="scss" rel="stylesheet/scss">
.head {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-top: 40px;

  .title {
    margin-bottom: 60px;
  }

  .auchanLogo {
    width: 186px;
  }

  .line {
    height: 40px;
  }
}
</style>
